export default "__VITE_ASSET__2Nx1vR2L__"